<template>
    <div class="table-logs">

        <div @click="router.back()" class="btn-back"><i class="material-icons">arrow_back_ios_new</i>Volver a participantes del curso</div>
        
        <template v-if="data">
            <h2>Eventos de <span>{{ data.fullName }}</span></h2>

            <div class="table-logs__menu">
                <h4>Detalle</h4>
                <div>
                    <button @click="modalNew.interactionForgeUserId = user.id ;modalNew.show = true"><i class="material-icons">add_circle</i>Agregar nueva interacción</button>
                    <div class="select-type">
                        <span @click="selectType.expand = !selectType.expand">{{ selectType.selected.name }} <i class="material-icons">keyboard_arrow_down</i></span>
                        <ul v-if="selectType.expand">
                            <li v-for="(option, idx) in selectType.options" :key="idx" @click="selectType.selected = option; pagination.page = 0; getInteractions(); selectType.expand = false">{{ option.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="table-pagination">
                <div class="table__container">

                    <div class="table">
                        <div class="table__head">
                            <span>FECHA</span>
                            <span>EVENTO</span>
                            <span>INTERLOCUTOR/A</span>
                            <span style="min-width: 0;"></span>
                        </div>
                        <div class="table__row" v-for="(row, idx) in data.data" :key="idx" :class="{ 'deleted' : row.body.isDeleted}">
                            <div class="isDeleted-label" v-if="row.body.isDeleted"><i class="material-icons">error</i>Interacción eliminada por {{ row.body.deletedBy }} el {{ formatDate(row.body.deletedDate) }}</div>
                            <div class="table__row__columns">
                                <span>{{ formatDate(row.interactionDate) }}</span>
                                <span>{{ row.eventTypeName }}</span>
                                <span>{{ row.interactionForgeUser || 'Carga automática' }}</span>
                                <span class="btn-more">
                                    <i class="material-icons" @click="data.data.forEach(el => el.showMenu = false); row.showMenu = !row.showMenu">more_vert</i>
                                    <div class="menu-more" v-if="row.showMenu">
                                        <span @click="!row.body.isDeleted && user.permissions.includes('INTERACCION_ELIMINACION') && row.interactionForgeUser ? modalDelete = row.id : ''" 
                                            :style="[{'opacity': row.body.isDeleted || !user.permissions.includes('INTERACCION_ELIMINACION') || !row.interactionForgeUser ? '.3' : '1'}, 
                                                    {'cursor': row.body.isDeleted || !user.permissions.includes('INTERACCION_ELIMINACION') || !row.interactionForgeUser ? 'default' : 'pointer'}]">
                                            <i class="material-icons">delete</i>Eliminar evento
                                        </span>

                                    </div>
                                </span>
                            </div>

                        <div class="table__row__description" v-if="row.body.title || row.body.description">
                            <strong>{{ row.body.title }}</strong>
                            <p :class="{'expanded' : row.expandDescription}">{{ row.body.description }}
                                <strong v-if="row.interactionForgeUser">Registrado por {{ row.body.createdBy || 'Carga automática' }}. Fecha: {{ formatDate(row.body.createdDate) }}</strong>
                            </p>
                            <div class="btn-expand">
                                <button v-if="!row.expandDescription && row.isOverflowing" @click="row.expandDescription = true">Ver más<i class="material-icons">keyboard_arrow_down</i></button>
                                <button v-if="row.expandDescription" @click="row.expandDescription = false">Ver menos<i class="material-icons">keyboard_arrow_up</i></button>
                            </div>
                        </div>

                        </div>               
                    </div>

                    <div v-if="!data.totalResults" style="width:1150px;padding:20px 0 20px 0;text-align:center">No hay resultados para mostrar...</div>
                </div>
                <div class="pagination" v-if="data.totalResults">
                    <button class="prev-next" @click.stop="selectPage('prev')" :disabled="pagination.page == 0"><i class="material-icons">arrow_back</i><span>Anterior</span> </button>
                    <!-- <div class="page"><span>{{'Página ' + (pagination.page+1)}}</span>{{' / ' + pagination.pages}}</div> -->
                    <!-- do it like <span>{{ Página ${params.page + 1 < 10 ? '0' + (params.page + 1) : params.page + 1} }}</span>{{  / ${pages < 10 ? '0' + pages : pages} }} -->
                    <div class="page"><span>{{ formattedPage }}</span>{{ formattedPages }}</div>
                    <button class="prev-next" @click.stop="selectPage('next')" :disabled="pagination.page+1 == pagination.pages"><span>Siguiente</span> <i class="material-icons">arrow_forward</i></button>
                </div>
            </div>
        </template>
        <Loader v-else />
    </div>


    <div class="modal__overlay" v-if="modalDelete">
        <div class="modal-confirm-delete">
            <h4>¿Estás seguro que deseas <span style="color: #009696">eliminar</span> esta interacción?</h4>
            <div class="buttons">
                <button class="cancel" @click="modalDelete = null">Cancelar</button>
                <button class="confirm" @click="deleteEvent()" :disabled="deletingEvent">Eliminar</button>
            </div>
        </div>
    </div>

    <div class="modal__overlay" v-if="modalNew.show">
        <div class="modal-new-interaction">
            <template v-if="!modalNew.confirmClose">
                <h2>Nueva interacción de <span>{{ data.fullName }}</span></h2>
                <div>
                    <DatePicker 
                        id="interaction-date"
                        label="Fecha de la interacción"
                        v-model="modalNew.interactionDate"
                        :to="new Date()"
                        :selectToday=true
                    />
                    <div v-if="modalNew.interactionForgeUserId == user.id" class="forgeUser">{{ `${user.firstName} ${user.lastName}` }}
                        <i v-if="user.permissions.includes('INTERACCION_CREACION_TERCEROS')" class="material-icons" @click="modalNew.interactionForgeUserId = null">close</i>
                    </div>
                    <InputDynamicSearch v-else
                        showProp="fullName"
                        storeReqPath="forge_searchForgeUser"
                        @selectResult="(forgeUser) => modalNew.interactionForgeUserId = forgeUser?.id || null"
                    />
                </div>
                <textarea v-model="modalNew.description" placeholder="Descripción" @keypress="limitCharacters($event)"></textarea>
                <div class="characters-count" :style="{'color': (modalNew.maxCharacters - modalNew.description.length) < 0 ? '#F57055' : ''}">{{ modalNew.maxCharacters - modalNew.description.length }} caracteres restantes</div>
                <div class="buttons">
                    <button class="cancel" @click="modalNew.description ? modalNew.confirmClose = true : modalNew.closeModal()">Cancelar</button>
                    <button class="confirm" @click="postEvent()" :disabled="(modalNew.maxCharacters - modalNew.description.length) < 0 || !modalNew.interactionDate || !modalNew.description || !modalNew.interactionForgeUserId || modalNew.sendingData">Guardar interacción</button>
                </div>
            </template>
            <template v-else>
                <h2 style="text-align: center;">¿Deseas <span style="color: #009696">cancelar</span> esta nueva interacción?</h2>
                <p>Se perderá toda la información que has cargado.<br>Esta acción no se puede deshacer.</p>
                <div class="buttons">
                    <button class="cancel" @click="modalNew.confirmClose = false">No, volver</button>
                    <button class="confirm" @click="modalNew.closeModal()">Si, cancelar</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { onMounted, inject, ref, onBeforeUnmount, nextTick  } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed } from '@vue/reactivity';
import Loader from '@/components/Loader.vue'
import DatePicker from '@/components/Inputs/DatePicker.vue';
import InputDynamicSearch from '@/components/Inputs/InputDynamicSearch.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const formatDate = inject('formatDate')
const user = computed(() => store.getters.manageUser_user);
/* const defaultUser = (() => {
  let { id, firstName, lastName } = user.value; // Sustituye estas propiedades con las que necesites
  return { id, firstName, lastName };
})(); */


const data = ref(null);
const pagination = ref({
    page: 0,
    rows: 5,
    pages: null,
    remainResults: null
})

const selectType = ref({
    selected: {id: "", name: 'Todos'},
    options: null,
    expand: false
});

const modalDelete = ref(null);
const deletingEvent = ref(false);

const formattedPage = computed(() => {
    // return 'Página ' + (params.value.page + 1 < 10 ? '0' + (params.value.page + 1) : params.value.page + 1);
    return 'Página ' + (pagination.value.page + 1 < 10 ? '0' + (pagination.value.page + 1) : pagination.value.page + 1);
});

const formattedPages = computed(() => {
    // return ' / ' + (pages.value < 10 ? '0' + pages.value : pages.value);
    return ' / ' + (pagination.value.pages < 10 ? '0' + pagination.value.pages : pagination.value.pages);
});

const modalNew = ref({
    show: false,
    interactionDate: null,
    interactionForgeUserId: null,
    description: '',
    learningUserId: route.params.studentId,
    maxCharacters: 3000,
    confirmClose: false,
    sendingData: false,
    closeModal: () => {
        modalNew.value.description = '';
        modalNew.value.interactionDate = null;
        modalNew.value.interactionForgeUserId = null;
        modalNew.value.show = false;
        modalNew.value.confirmClose = false;
    }
})

function limitCharacters(ev){
    if(modalNew.value.description.length >= modalNew.value.maxCharacters) ev.preventDefault();
}

function selectPage(prevNext){
    if(prevNext == 'next') pagination.value.page++;
    else if(prevNext == 'prev') pagination.value.page--;
    getInteractions()
}

async function deleteEvent(){
    deletingEvent.value = true;
    try {
        await store.dispatch('interactions_delete', modalDelete.value);
        modalDelete.value = null;
        getInteractions();
        deletingEvent.value = false;
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', {text: 'Error al eliminar interacción'});
        deletingEvent.value = false;
    }
}

async function postEvent(){
    console.log(modalNew.value)
    modalNew.value.sendingData = true;
    try {
        await store.dispatch('interactions_post', modalNew.value);
        modalNew.value.closeModal();
        pagination.value.page = 0;
        getInteractions();
        modalNew.value.sendingData = false;
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', {text: 'Error al crear interacción'});
        modalNew.value.sendingData = false;
    }
}

async function getTypes(){
    let req = await store.dispatch('interactions_getTypes');
    console.log(req.data)
    selectType.value.options = req.data;
    selectType.value.options.push({id: '', name: 'Todos'})
}

function checkOverflow(idx) {
    const description = document.querySelectorAll('.table__row__description p')[idx];
    if (description) {
        data.value.data[idx].isOverflowing = description.scrollHeight > description.clientHeight;
    }
}

async function getInteractions(){
    data.value = null;
    let req = await store.dispatch('interactions_get', {studentId: route.params.studentId, page: pagination.value.page, rows: pagination.value.rows, type: selectType.value.selected.id} );
    data.value = req.data;
    pagination.value.remainResults = req.data.totalResults - (pagination.value.page * pagination.value.rows);
    pagination.value.pages = Math.ceil(req.data.totalResults / pagination.value.rows);
    nextTick(() => {
        data.value.data.forEach((row, idx) => {
            checkOverflow(idx);
        });
    });
}

const hideModals = (event) =>{
    if(!event.target.closest('.select-type')) selectType.value.expand = false;
    if(!event.target.closest('.btn-more')) {
        data.value.data.forEach(row => row.showMenu = false)
    }
}

onMounted(async () => {
    getTypes();
    await getInteractions();
    document.body.addEventListener('click',hideModals)
});

onBeforeUnmount(()=>{
    document.body.removeEventListener('click', hideModals)
})

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

$columnWidth: 200px;

@mixin modal-buttons{
    padding-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 42px;
    .cancel{
        color: $green;
        font-weight: 600;
    }
    .confirm{
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 26px;
        background: $green;
        color: #fff;
        font-weight: 600;
        border-radius: 44px;
        &:disabled{
            opacity: .6;
            cursor: default;
        }
    }
}

.btn-back{
    width: fit-content;
    margin-bottom: 42px;
    @include icon-and-text-container;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 12px;
    }
}

.modal-confirm-delete{
    padding: 24px;
    background: #fff;
    border-radius: 10px;
    .buttons{
        @include modal-buttons;
        margin-top: 16px;
    }
}

.modal-new-interaction{
    width: 98%;
    max-width: 660px;
    padding: 36px;
    background: #fff;
    border-radius: 10px;
    h2{
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 28px;
        span{
            color: $green;
        }
    }
    >div{
        display: flex;
        gap: 24px;
    }
    .forgeUser{
        height: 50px;
        width: 100%;
        max-width: 282px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f5f5f5;
        padding: 12px 18px 12px 28px;
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        border-radius: 50px;
        .material-icons{
            cursor: pointer;
        }
    }
    textarea{
        width: 100%;
        height: 300px;
        margin: 22px 0 0px 0;
        padding: 8px 28px;
        resize: none;
        background-color: #F6F6F6;
        border: none;
        outline: none;
        border-radius: 10px;
        &::placeholder{
            color: $green;
            font-weight: 600;
        }
    }
    .characters-count{
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        font-size: 11px;
        font-weight: 400;
        font-style: italic;
        color: #515151;
    }
    p{
        margin-bottom: 24px;
        text-align: center;
        line-height: 32px
    }
    .buttons{
        @include modal-buttons;
    }
}

.table-logs{
    width: 100%;
    max-width: 1116px;
    margin: 0 auto;
    padding: 32px 12px 80px 12px;
    >h2{
        margin-bottom: 32px;
        padding-bottom: 16px;
        font-size: 20px;
        font-weight: 700;
        border-bottom: 1px solid rgba(217, 217, 217, 0.3);
        span{
            color: $green;
        }
    }
    &__menu{
        margin-bottom: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 24px;
        >div{
            display: flex;
            gap: 56px;
            button{
                @include icon-and-text-container;
                color: $green;
                font-size: 13px;
                font-weight: 600;
                .material-icons{
                    font-size: 21px;
                }
            }
        }
        .select-type{
            position: relative;
            font-size: 13px;
            font-weight: 500;
            span{
                width: 160px;
                padding: 4px 8px 4px 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 16px;
                border: 1px solid;
                border-radius: 25px;
                cursor: pointer;
            }
            ul{
                width: 100%;
                position: absolute;
                top: 36px;
                padding: 12px 0 8px 16px;
                display: flex;
                flex-direction: column;
                gap: 6px;
                background: #fff;
                box-shadow: 0px 4px 4px 0px #00000040;
                border-radius: 10px;
                z-index: 20;
                li{
                    padding: 1px 0;
                    cursor: pointer;
                }
            }
        }
    }
    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
    @media(max-width:980px) {
        .table__container {
            overflow-x: auto;
        }
    }
    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding-bottom: 0;
        &__head{
            padding-bottom: 8px;
            display: grid;
            grid-template-columns: repeat(3, 1fr) 24px;
            padding: 16px;
            >span{
                font-size: 14px;
                font-weight: 700;
                flex-grow: 1;
                min-width: $columnWidth;
            }
        }
        &__row{
            padding: 16px;
            // padding: 6px 0;
            // margin-bottom: 10px;
            border-bottom: 1px solid rgba(217, 217, 217, 0.3);
            font-size: 13px;
            &.deleted{
                background-color: #FFF5E8;
                .isDeleted-label{
                    padding-left: 6px;
                    @include icon-and-text-container;
                    color: $orange;
                    font-size: 13px;
                    font-weight: 600;
                    .material-icons{
                        font-size: 18px;
                    }
                }
            }
            &__columns{
                padding: 12px 0;
                display: grid;
                grid-template-columns: repeat(3, 1fr) 24px;
                font-weight: 500;
                >span{
                    min-width: $columnWidth;
                    &.btn-more{
                        position: relative;
                        min-width: 0;
                        cursor: pointer;
                        .menu-more{
                            position: absolute;
                            top: -10px;
                            right: 26px;
                            width: 160px;
                            padding: 16px;
                            background: #fff;
                            span{
                                @include icon-and-text-container;
                                font-size: 13px;
                                font-weight: 600;
                                .material-icons{
                                    font-size: 18px;
                                }
                            }
                            border-radius: 10px;
                            box-shadow: 0px 4px 4px 0px #00000040;
                        }
                    }
                }
            }
            &__description{
                min-width: 600px;
                padding: 0 16px;
                color: #515151;
                strong{
                    font-weight: 600;
                }
                p{
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin: 0;
                    &.expanded{
                        -webkit-line-clamp: unset;
                    }
                }
                .btn-expand{
                    padding-top: 6px;
                    display: flex;
                    justify-content: flex-end;
                    button{
                        @include icon-and-text-container;
                        gap: 2px;
                        font-size: 14px;
                        font-weight: 400;
                        color: $green;
                        .material-icons{
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }
}

</style>